const captured = new Map();

const purposesByPath = {
  "/reset-password": "password_reset",
  "/uitnodiging": "invitation",
  "/verify-email": "email_verification",
};

// Run before Vue mounts. Fragments are never sent to Rails, and removing the token
// immediately keeps browser telemetry, screenshots, and copied URLs clean too.
export function captureSensitiveToken() {
  const purpose = purposesByPath[window.location.pathname];
  if (!purpose || !window.location.hash) return;

  const token = new URLSearchParams(window.location.hash.slice(1)).get("token");
  if (token) captured.set(purpose, token);
  window.history.replaceState(window.history.state, "", `${window.location.pathname}${window.location.search}`);
}

export function consumeSensitiveToken(purpose) {
  const token = captured.get(purpose) ?? null;
  captured.delete(purpose);
  return token;
}
